module.exports = __webpack_public_path__ + "static/notes-fd80171134d8e339cf35779e56d9aa6d.png";